import Main from "./components/Main";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <h1>Frontend Mentor Challenges</h1>
      <Main />
    </div>
  );
}
